<template>
  <div id="game-layout">
    <Suspense>
      <main>
        <router-view v-slot="{ Component, route }">
          <transition mode="out-in" name="fade">
            <div :key="route.name">
              <component :is="Component" :id="route.name" />
            </div>
          </transition>
        </router-view>
      </main>
    </Suspense>
  </div>
</template>

<script setup lang="ts">
import { useDark, useToggle } from "@vueuse/core";
import { useCandidateStore } from "@/stores/candidate";
import { onMounted, watch, inject } from "vue";

const isDark = useDark();
const route = useRoute();

const toggleDark = useToggle(isDark);

if (!isDark.value) toggleDark();

const crisp = inject("crisp");

const { candidate } = useCandidateStore();

const currentVersion = ref(null)

async function checkVersion() {
  const res = await fetch('/version.json');
  const data = await res.json();

  if (route.name !== 'game-waiting') {
    if (currentVersion.value && currentVersion.value !== data.version) {
      window.location.reload();
    }

    axiosInstance.defaults.headers.common['x-app-version'] = data.version; // Add the version to the headers
    currentVersion.value = data.version;
  }
}

watch(candidate, () => {
  if (candidate.id) {
    crisp.user.setEmail(candidate.personal_information.email);
    crisp.user.setNickname(`${candidate.personal_information.first_name} ${candidate.personal_information.last_name}`);
    crisp.session.setData({
      user_id: candidate.id,
    });
  }
});

onMounted(async () => {
  crisp.session.setSegments(["Candidat"]);
  checkVersion();
  setInterval(checkVersion, 5000); // check every 5s
});
</script>
